(() => {
  if (window.__kwContentSliderLoaded === true) return;
  window.__kwContentSliderLoaded = true;
  const SELECTOR = '[data-kw-content-slider]';

  function setup(root) {
    if (!(root instanceof Element) || root.dataset.kwSliderReady === 'true') return;
    const track = root.querySelector('[data-kw-content-slider-track]');
    const controls = root.querySelector('.kw-content-slider__controls');
    const previous = root.querySelector('[data-kw-content-slider-previous]');
    const next = root.querySelector('[data-kw-content-slider-next]');
    if (!track) return;
    root.dataset.kwSliderReady = 'true';

    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const overflow = max > 2;
      if (previous && next) {
        if (controls) controls.hidden = !overflow;
        previous.hidden = !overflow;
        next.hidden = !overflow;
        previous.disabled = !overflow || track.scrollLeft <= 2;
        next.disabled = !overflow || track.scrollLeft >= max - 2;
      }
    };

    const step = () => {
      const card = track.querySelector('.kw-content-slider__card');
      if (!card) return track.clientWidth;
      const style = getComputedStyle(track);
      const gap = Number.parseFloat(style.columnGap || style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const scroll = (direction) => {
      track.scrollBy({left: step() * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };

    previous?.addEventListener('click', () => scroll(-1));
    next?.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', update, {passive: true});
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      scroll(event.key === 'ArrowLeft' ? -1 : 1);
    });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update, {passive: true});
    update();
  }

  function setupAll(container = document) {
    container.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupAll());
  else setupAll();
  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
